import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "@/i18n/i18n";

export default function LanguageSelector({ compact = false }) {
    const { i18n, t } = useTranslation();
    const current = (i18n.language || "en").split("-")[0];

    return (
        <label
            className={`inline-flex items-center gap-2 text-xs text-[var(--ink-muted)] ${
                compact
                    ? ""
                    : "border border-[var(--border-strong)] rounded-full px-4 py-2 bg-[var(--bg-elevated)]"
            }`}
        >
            <Languages size={14} strokeWidth={1.5} className="text-[var(--ink)]" />
            <span className="uppercase tracking-widest sr-only">{t("language.label")}</span>
            <select
                data-testid="language-selector"
                value={current}
                onChange={(e) => i18n.changeLanguage(e.target.value)}
                className="bg-transparent border-0 outline-none text-[var(--ink)] text-sm cursor-pointer"
            >
                {SUPPORTED_LANGUAGES.map((l) => (
                    <option key={l.code} value={l.code}>
                        {l.label}
                    </option>
                ))}
            </select>
        </label>
    );
}
